module.exports = __webpack_public_path__ + "img/LegalIcon.8029e45b.svg";